import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AddOnsStore } from 'pages/settings/pages/addOns/store/addOnsStore'

export const AddOnsViewContext = createContext<AddOnsStore | null>(null)

export const useAddOnsViewContext = () => {
  const context = useContext(AddOnsViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AddOnsViewContext')

  return context
}

export const AddOnsViewProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new AddOnsStore(entities), [])

  useEffect(() => {
    void store.init()
  }, [])

  return <AddOnsViewContext.Provider value={store}>{children}</AddOnsViewContext.Provider>
}
